import { render, staticRenderFns } from "./webDetails.vue?vue&type=template&id=5e045839&scoped=true&"
import script from "./webDetails.vue?vue&type=script&lang=js&"
export * from "./webDetails.vue?vue&type=script&lang=js&"
import style0 from "./webDetails.vue?vue&type=style&index=0&id=5e045839&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e045839",
  null
  
)

export default component.exports